export default __webpack_public_path__ + "static/media/Kuthcheman Sagaris.fe514468.jpg";